import { memo } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { TextInput } from 'reactGarden/Input'

import { fieldsetStyles, fieldStyles, labelStyles, placeholderStyles, messageStyles } from './styles'

const Fieldset = styled('fieldset')(fieldsetStyles)
const FieldElement = styled(TextInput)(fieldStyles)
const Label = styled('span')(labelStyles)
const Placeholder = styled('span')(placeholderStyles)
const Message = styled('span')(messageStyles)

const showErrors = (errors) => {
  const errorMessage = {
    required: 'Campo obrigatório.',
    maxLength: 'Limite máximo de 40 caracteres.'
  }

  if (errors.type) {
    return (
      <Message>
        {errorMessage[errors.type]}
      </Message>
    )
  }
}

const Field = ({
  name,
  title,
  errors,
  reference,
  placeholder,
  noPlaceholder,
  ...rest
}) => {
  const showPlaceholder = () => {
    if (noPlaceholder) {
      return null
    }

    return (
      <Placeholder>
        {placeholder}
      </Placeholder>
    )
  }

  return (
    <Fieldset>
      <Label htmlFor={name}>{title}</Label>
      <FieldElement id={name} name={name} ref={reference} {...rest} />
      {errors
        ? showErrors(errors)
        : showPlaceholder()
      }
    </Fieldset>
  )
}

Field.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  errors: PropTypes.object,
  reference: PropTypes.func,
  placeholder: PropTypes.string,
  noPlaceholder: PropTypes.bool
}

Field.defaultProps = {
  name: 'input',
  title: 'Preencha o campo abaixo:',
  placeholder: 'Ex: João da Silva',
  noPlaceholder: false
}

const areEqual = (prevProps, nextProps) => {
  return prevProps.errors === nextProps.errors
}

export default memo(Field, areEqual)
